import React from 'react'

import styles from './secondHeadTitle.module.scss'

const SecondHeadTitle = props => {
  return (
    <div className={styles.secondHeadTitle}>
      {props.children}
    </div>
  )
}

export default React.memo(SecondHeadTitle)